// src/pages/Home.tsx
import React, { Suspense } from "react";

import PageLayout from "../layouts/PageLayout";
import CLINIC_CONFIG from "../config/clinicConfig";
import BackGroundVideo from '../components/common/BackgroundVideo/BackgroundVideo';
import ConvenientPart from '../components/home/ConvenientPart/ConvenientPart';
import AffordablePart from '../components/home/AffordablePart/AffordablePart';
import OurServicesSection from '../components/home/OurServicesSection/OurServicesSection';
import MobileServicesSection from '../components/home/MobileServicesSection/MobileServicesSection';
import "../components/styles/styles.css";
import { useSeasonalTheme } from '../hooks/useSeasonalTheme';

import { HOME_META, HOME_HERO, HOME_FAQS, HOME_HIDDEN_H1 } from "../content/pages/homeContent";

// Below-the-fold sections loaded on demand
const GoogleReviews = React.lazy(() => import('../components/home/GoogleReviews/GoogleReviews'));
const BeforeAfterSection = React.lazy(() => import('../components/home/BeforeAfterSection/BeforeAfterSection'));
const FAQAccordion = React.lazy(() => import('../components/common/FAQAccordion/FAQAccordion'));

// Seasonal pages — only downloaded when the date matches
const ChristmasHome = React.lazy(() => import('../components/seasonal/christmas/ChristmasPage'));
const HalloweenHome = React.lazy(() => import('./seasonal/Halloween'));

const Home: React.FC = () => {
  const { isChristmas, isHalloween } = useSeasonalTheme();

  // ── Seasonal override: render themed homepage when active ──
  if (isChristmas) return <Suspense fallback={null}><ChristmasHome /></Suspense>;
  if (isHalloween) return <Suspense fallback={null}><HalloweenHome /></Suspense>;

  // ── Default homepage ──
  return (
    <PageLayout
      title={HOME_META.title}
      description={HOME_META.description}
      keywords={HOME_META.keywords}
      canonicalPath="/"
      hiddenH1={HOME_HIDDEN_H1}
    >
      <BackGroundVideo headingLines={HOME_HERO.headingLines} />

      <ConvenientPart />
      <AffordablePart />
      <div className="d-none d-lg-block">
        <OurServicesSection />
      </div>
      <MobileServicesSection />

      <Suspense fallback={null}>
        <GoogleReviews />
        <BeforeAfterSection />
        <FAQAccordion title={`Dental Care FAQs — ${CLINIC_CONFIG.clinicName}, ${CLINIC_CONFIG.stateShortForm}`} faqs={HOME_FAQS} />
      </Suspense>
    </PageLayout>
  );
};

export default Home;
